import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import ApiProvider from "../../../apiProvider.js";
//import { DatePicker, DatePickerInput, Button, Link, TimePicker,InlineLoading, Modal, Spinner } from 'react-bootstrap';
import { RequiredDate } from "../../../Components/form_elements/form-validators.js";
import {
    Spinner,
    Form,
    Button,
    Modal,
    Container,
    Col,
    Row,
} from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { formatDateToServer } from "../../../Components/formatters.js";
import "../../../Components/styles/table.scss";
import moment from "moment-timezone";
import PDFViewer from "../../../Components/PDFViewer/PDFViewer.jsx";
import EmployeeLookup from "../../../Components/EmployeeLookup/EmployeeLookup.jsx";
import { HubConnectionBuilder } from "@microsoft/signalr";
import MobilePDFViewer from "../../../Components/PDFViewer/MobilePDFViewer.jsx";
import { isMobile } from "../../../mobileHelper.js";
import AddPayslip from "./add-payslip.jsx";
import PayslipList from "./payslip-list.jsx";
import { CdsActionModal, CdsContentPanel } from "clayco-component-library";

import {
    CdsDateField,
    CdsForm,
    CdsInputField,
    useFormContext,
} from "clayco-component-library";
import * as yup from "yup";

const Payslips = ({ currentLocation, setMenuOptions }) => {
    const { instance, accounts } = useMsal();
    const apiProvider = new ApiProvider(instance, accounts[0]);
    const [payChecks, setPayChecks] = useState([]);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [useDate, setUseDate] = useState(false);
    const [infoMessage, setInfoMessage] = useState(
        "Showing 10 most recent payslips"
    );
    const [showModal, setShowModal] = useState(false);
    const [selectedFile, setSelectedFile] = useState("");
    const [loading, setLoading] = useState(true);
    const [isPayslipAdmin, setIsPayslipAdmin] = useState(false);
    const [payslipMessage, setPayslipMessage] = useState("Showing my payslips");
    const [error, setError] = useState(false);
    const [importing, setImporting] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState();
    const [emailDeliveryDate, setEmailDeliveryDate] = useState(
        moment().day(4).format("MM/DD/YYYY")
    );
    const [emailDeliveryTime, setEmailDeliveryTime] = useState(
        moment().hour(17).minute(0).format("HH:mm")
    );
    const [EmailDeliveryDateTime, setEmailDeliveryDateTime] = useState(
        new moment(
            moment().day(4).hour(17).minute(0).format("MM/DD/YYYY HH:mm"),
            "MM/DD/YYYY HH:mm"
        )
            .utc()
            .format()
    );
    const [payslipIdForDeletion, setPayslipIdForDeletion] = useState("");
    const [showAdd, setShowAdd] = useState();
    const [payslipSubmitted, setPayslipSubmitted] = useState();
    const [todayMinusThreeYears, setTodayMinusThreeYears] = useState();
    const [today, setToday] = useState();
    const [searchCollapsed, setSearchCollapsed] = useState(true);
    const [titleDescription, setTitle] = useState("Click to expand search options");

    useEffect(()=> {
        if(!searchCollapsed){
            setTitle("Click to hide search options");
        }
        else{
            setTitle("Click to expand search options");
        }
    }, [searchCollapsed])

    useEffect(() => {
        if (accounts[0].idTokenClaims?.roles?.includes("PayslipAdmin")) {
            setIsPayslipAdmin(true);
        } else {
            setIsPayslipAdmin(false);
        }

        GetRecent();
        setMenuOptions("Payslips");
    }, []);

    useEffect(() => {
        if (payslipSubmitted === true) {
            onEmployeeSelected(selectedEmployee);
        }
    }, [payslipSubmitted]);

    async function GetRecent() {
        let recentPayChecks = await GetPaychecksRecentForUser();

        if (!recentPayChecks.error) {
            setPayChecks(recentPayChecks);
        } else {
            setError(true);
        }
        setLoading(false);
        setPayslipSubmitted(false);
    }

    let handleSearchDates = async () => {
        setUseDate(true);
        onEmployeeSelected(selectedEmployee, true);
    };

    function getPaycheck(id) {
        setShowModal(true);
        setSelectedFile(`Payslip/Employee/PayslipFile/${id}`);
    }

    function GetPaychecksByEmployeeAndDate(employeeId, start, end) {
        return apiProvider.Get(
            `Payslip/${employeeId}/ByDate/${formatDateToServer(
                start
            )}/${formatDateToServer(end)}`
        );
    }

    function GetRecentPaychecksByEmployee(employeeId) {
        return apiProvider.Get(`Payslip/${employeeId}/Recent`);
    }

    function GetPaychecksRecentForUserByDate(start, end) {
        return apiProvider.Get(
            `Payslip/Employee/ByDate/${formatDateToServer(
                start
            )}/${formatDateToServer(end)}`
        );
    }

    function GetPaychecksRecentForUser() {
        return apiProvider.Get(`Payslip/Employee/Recent`);
    }

    async function handleImportClick() {
        setImporting(true);
        const connection = new HubConnectionBuilder()
            .withUrl(`${window.env.baseUrl}/api/payslipHub`)
            .build();

        // connect to method that hub invokes
        connection.on("receiveProgress", (message) => {
            connection.stop().then(() => {
                setImporting(false);
                console.log("connection has been closed");
                alert(`Import of file ${message} has been completed.`);
            });
            console.log(message);
        });

        // start connection
        connection.start().then((e) => {
            connection.invoke("JoinGroup", "payslips");
            console.log("Connection to enrollments hub has started");
        });
        let response = await apiProvider.Post("Payslip/Admin/TriggerImport", {
            emailDeliveryTime: EmailDeliveryDateTime,
        });
        if (response.error) {
            setImporting(false);
        }
    }

    useEffect(() => {
        //debugger;
        onEmployeeSelected(selectedEmployee);
    }, [selectedEmployee, startDate, endDate]);

    const onChangeDateHandlerStart = (value) => {
        if (value) {
            let end = moment(value).format("MM/DD/YYYY");
            setStartDate(end);
        } else {
            setStartDate("");
        }
    };

    const onChangeDateHandlerEnd = (value) => {
        if (value) {
            let end = moment(value).format("MM/DD/YYYY");
            setEndDate(end);
        } else {
            setEndDate("");
        }
    };

    const clearDates = async () => {
        setStartDate("");
        setEndDate("");
        setUseDate(false);
    };

    const getFormattedDate = (d) => {
        var date = new Date(d);
        if (!d) return null;
        let year = date.getFullYear();
        let month = (1 + date.getMonth()).toString().padStart(2, "0");
        let day = date.getDate().toString().padStart(2, "0");

        return month + "/" + day + "/" + year;
    };

    function onEmployeeSelected(employee, isDateRange = null) {
        //debugger;
        setSelectedEmployee(employee);

        let useDates = false;
        let fromDate = "";
        let toDate = "";
        if (
            (startDate !== "" && startDate !== undefined) ||
            (endDate !== "" && endDate !== undefined)
        ) {
            useDates = true;

            if (startDate !== "" && startDate !== undefined) {
                fromDate = startDate;
            } else {
                fromDate = "01/01/1901";
            }

            if (endDate !== "" && endDate !== undefined) {
                toDate = endDate;
            } else {
                let today = new Date();
                toDate = moment(today).format("MM/DD/YYYY");
            }
        }

        setLoading(true);
        let response = null;

        if (useDates) {
            setInfoMessage(
                `Showing Payslips issued between ${getFormattedDate(
                    fromDate
                )} and ${getFormattedDate(toDate)}`
            );
        } else {
            setInfoMessage("Showing 10 most recent payslips");
        }

        if (employee) {
            setPayslipMessage(`Showing payslips for ${employee.displayName}`);
            if (useDates === true) {
                response = GetPaychecksByEmployeeAndDate(
                    employee.id,
                    fromDate,
                    toDate
                );
            } else {
                response = GetRecentPaychecksByEmployee(employee.id);
            }
        } else {
            if (useDates === true) {
                response = GetPaychecksRecentForUserByDate(fromDate, toDate);
            } else {
                response = GetPaychecksRecentForUser();
            }
        }

        response.then((result) => {
            if (!result.error) {
                setPayChecks(result);
            }
            setLoading(false);
        });
    }

    const emailDeliveryDateChange = (e) => {
        let deliveryDate = getFormattedDate(e);
        console.log(deliveryDate);
        setEmailDeliveryDate(deliveryDate);
        console.log(deliveryDate + " " + emailDeliveryTime);
        var utcTime = new moment(
            emailDeliveryDate + "T" + emailDeliveryTime,
            "MM/DD/YYYYTHH:mm"
        )
            .utc()
            .format();

        console.log("TIME=", utcTime);
        setEmailDeliveryDateTime(utcTime);
    };

    const emailDeliveryTimeChange = (e) => {
        let time = e.target.value;
        var utcTime = new moment(
            emailDeliveryDate + "T" + time,
            "MM/DD/YYYYTHH:mm"
        )
            .utc()
            .format();

        setEmailDeliveryTime(e.target.value);
        setEmailDeliveryDateTime(utcTime);
    };

    const confirmDelete = (payslipIdForDeletion) => {
        console.log(payslipIdForDeletion);
        setPayslipIdForDeletion(payslipIdForDeletion);
    };

    const deletePayslip = async () => {
        let response = await apiProvider.Delete(
            `Payslip/${payslipIdForDeletion}`
        );
        if (!response.error) {
            setPayslipIdForDeletion(null);
            if (selectedEmployee) {
                onEmployeeSelected(selectedEmployee);
            } else {
                await GetRecent();
            }
        }
    };

    useEffect(() => {
        const currentDate = new Date();

        function subtractYears(date, years) {
            date.setFullYear(date.getFullYear() - years);
            return date;
        }

        setTodayMinusThreeYears(subtractYears(currentDate, 3));
        setToday(new Date());
    }, []);

    const onError = (errors, e) => {
        console.log("Form Submission Error", errors);
    };

    const formSchema = yup.object().shape({
        dateFrom: RequiredDate("From date is required"),
        dateTo: RequiredDate("To date is required"),
    });

    const scheduleFormSchema = yup.object().shape({
        payslipsEmail: yup.date().required("This date is required"),
    });

    const handleScheduleFormSubmit = () => {};

    return (
        <Container fluid>
            <CdsForm
                schema={scheduleFormSchema}
                onSubmit={handleScheduleFormSubmit}
                onError={console.log(
                    "Error submitting Payslip scheduling form."
                )}
            >
                {isPayslipAdmin && (
                    <>
                        <div className="row">
                            <div className="col">
                                <h4 className="mb-0">Schedule & Import</h4>
                                <hr className="mt-2" />
                            </div>
                        </div>
                        <div className="d-flex flex-wrap justify-content-start align-items-start mb-5">
                            <div className="me-3">
                                <CdsDateField
                                    label="Send Emails for Payslips on"
                                    name="payslipsEmails"
                                    initialDate={null}
                                    placeholder="mm/dd/yyyy"
                                    onChange={emailDeliveryDateChange}
                                ></CdsDateField>
                            </div>
                            <div className="me-3">
                                <Form.Group>
                                    <Form.Label className="mb-0">
                                        at:
                                    </Form.Label>
                                    <Form.Control
                                        id="time-picker"
                                        labelText="at:"
                                        type="time"
                                        value={emailDeliveryTime}
                                        onChange={emailDeliveryTimeChange}
                                    />
                                </Form.Group>
                            </div>
                            <div className="break"></div>
                            <div className="pb-1">
                                {!loading ? (
                                    <Button
                                        className="mt-4 me-5"
                                        onClick={handleImportClick}
                                    >
                                        Schedule &amp; Import PDFs
                                    </Button>
                                ) : (
                                    <Button className="mt-4" disabled>
                                        <Spinner
                                            style={{
                                                height: "14px",
                                                width: "14px",
                                                borderWidth: "2px",
                                                marginRight: "8px",
                                            }}
                                            description="Importing Payslips"
                                            status={
                                                importing
                                                    ? "active"
                                                    : "finished"
                                            }
                                        />
                                        Loading
                                    </Button>
                                )}
                            </div>
                        </div>
                    </>
                )}
            </CdsForm>
            <CdsContentPanel
                title="Payslips"
                description={titleDescription}
                collapsible={true}
                collapsed={searchCollapsed}
                onCollapseStateChange={(evt)=>{setSearchCollapsed(!searchCollapsed)}}
            >
                <CdsForm
                    schema={formSchema}
                    onSubmit={handleSearchDates}
                    onError={onError}
                >
                    <div className="row align-items-start payslip-search">
                        {isPayslipAdmin && (
                            <div className="col col-12 col-xl-6">
                                <EmployeeLookup
                                    label={'Find Employee'}
                                    onEmployeeSelected={onEmployeeSelected}
                                    formSchema={formSchema}
                                ></EmployeeLookup>
                            </div>
                        )}
                        <div className="col col-12 col-xl-2">
                            <CdsDateField
                                label="From"
                                name="dateFrom"
                                key="dateFrom"
                                id="dateFrom"
                                onChange={onChangeDateHandlerStart}
                                initialDate={startDate}
                                showIcon={true}
                                placeholder={"mm/dd/yyyy"}
                                minDate={todayMinusThreeYears}
                                maxDate={today}
                            ></CdsDateField>
                        </div>
                        <div className="col col-12 col-xl-2">
                            <CdsDateField
                                label="To"
                                name="dateTo"
                                key="dateTo"
                                id="dateTo"
                                onChange={onChangeDateHandlerEnd}
                                initialDate={endDate}
                                showIcon={true}
                                placeholder={"mm/dd/yyyy"}
                                minDate={todayMinusThreeYears}
                                maxDate={today}
                            ></CdsDateField>
                        </div>
                        <div className="col col-12 col-xl-2">
                            <Button size="md" kind="primary" onClick={clearDates}>
                                Clear Dates
                            </Button>
                        </div>
                    </div>
                </CdsForm>
            </CdsContentPanel>
            <div className="row mt-4">
                        {isPayslipAdmin && (
                            <div className="col col-12 col-md-6">
                                <p className="mb-0">
                                    {payslipMessage}
                                    <button
                                        className="btn btn-link cds-link p-0 pb-1 ps-1"
                                        onClick={() => {
                                            setShowAdd(true);
                                        }}
                                    >
                                        Add Payslip
                                    </button>
                                </p>
                            </div>
                        )} 
            <div className="col col-12 col-md-6">
                <p className={"mb-0 text-start d-block d-md-none"}>
                    {infoMessage}
                </p>
                <p
                    className={
                        isPayslipAdmin
                            ? "mb-0 text-end d-none d-md-block"
                            : "mb-0 text-start d-none d-md-block"
                    }
                >
                    {infoMessage}
                </p>
            </div>
            </div>
            <PayslipList
                payslips={payChecks}
                viewPayslip={getPaycheck}
                onDeletePayslip={confirmDelete}
                isPayslipAdmin={isPayslipAdmin}
            ></PayslipList>

            <CdsActionModal
                show={payslipIdForDeletion}
                handleCloseClick={() => setPayslipIdForDeletion("")}
                primaryButtonText="Delete"
                primaryButtonAction={deletePayslip}
                secondaryButtonText="Cancel"
                secondaryButtonAction={() => setPayslipIdForDeletion("")}
                disablePrimaryButton={false}
            >
                <p className="text-center pt-3">
                    Are you sure you want to delete this payslip?
                </p>
            </CdsActionModal>

            <AddPayslip
                show={showAdd}
                setShow={setShowAdd}
                selectedEmployee={selectedEmployee}
                setPayslipSubmitted={setPayslipSubmitted}
            />
        </Container>
    );
};
export default Payslips;
